import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { publicApi } from '../lib/api.ts';
import { CenteredSpinner } from '../components/Spinner.tsx';
import { ErrorMessage } from '../components/ErrorMessage.tsx';
import { useBranding } from '../lib/branding.tsx';

export function DriverLanding() {
  const { token = '' } = useParams();
  const { branding } = useBranding();
  const [error, setError] = useState<unknown>(null);
  const ranRef = useRef(false);
  const brandName = branding.companyName?.replace(/ Safety.*$/i, '') ?? 'Locate2u';

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    if (!token) {
      setError(new Error('Missing invite token'));
      return;
    }
    publicApi
      .post<{ action_link: string }>('/api/auth/driver/redeem', { token })
      .then((body) => {
        if (!body?.action_link) throw new Error('Redeem returned no action link');
        window.location.href = body.action_link;
      })
      .catch((err) => setError(err));
  }, [token]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
        <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8 shadow-sm">
          {branding.logoUrl && (
            <img src={branding.logoUrl} alt={brandName} className="mb-3 h-10 w-auto" />
          )}
          <div className="brand-wordmark text-xl" style={{ color: 'var(--brand-primary)' }}>
            Safety<span className="accent">&amp;</span>Compliance
          </div>
          <p className="mt-4 text-sm text-slate-500">
            We couldn’t process your invitation link. It may have expired or already been used.
          </p>
          <div className="mt-4">
            <ErrorMessage error={error} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50">
      <CenteredSpinner />
      <p className="text-sm text-slate-500">Preparing your sign-in…</p>
    </div>
  );
}
